import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AsyncLocalStorage} from 'angular-async-local-storage';
import {Router} from '@angular/router';
import {User} from './models';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/delay';
import {Subject} from 'rxjs/Subject';
// C4 error mapping message+CTA only (contratos-congelados T5, R5 + R9).
// Data-only helper: never navigates and never blocks unknown shapes.
// Callers render the returned message and follow cta when present:
// '/pago' is a router path, 'contacto' is a symbolic support action
// (no /contacto route exists). Unknown shapes fall through to a raw
// passthrough with cta null. No delete-account flow exists in frontend,
// so unknown terminal shapes reach that passthrough by construction (Q9).
export interface AuthErrorInfo {
  message: string | null;
  cta: string | null;
  code: string | null;
  feature?: string | null;
  planId?: string | null;
  maxScreens?: number | null;
  screensInUse?: number | null;
}

@Injectable()
export class Auth {
  url; // api url
  user; // user token
  token_key = 'captamedia_user'; // key for user token
  circuito;
  private USE_MOCK = false;
  subscriptionChanged: Subject<void> = new Subject<void>();

  get isMockMode(): boolean {
    return this.USE_MOCK;
  }

  constructor(public http: HttpClient,
              protected storage: AsyncLocalStorage,
              private router: Router) {
    this.url = environment.server;
    this.gettoken();
  }

  uploadHeaders() {
    return {'Authorization': this.user ? 'Bearer ' + this.user.token : ''};
  }

  headers() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  /******* Authorization Methods *******/

  gettoken() {
    this.storage.getItem<User>(this.token_key).subscribe((data) => {
      this.user = data;
      console.log(this.user);
    });
  }

  getUser() {
    return this.storage.getItem<User>(this.token_key);
  }

  headersAuth() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', this.user ? 'Bearer ' + this.user.token : '');
    return headers;
  }

  headersFileAuth() {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.user ? 'Bearer ' + this.user.token : '');
    return headers;
  }

  login(body) {
    console.log(this.url);
    const headers = this.headers();
    return this.http.post(this.url + '/api/init/login', body, {headers: headers});
  }

  loginIn(user) {
    this.user = user;
    return this.storage.setItem(this.token_key, user);
  }

  _logout(token) {
    const headers = this.headers();
    return this.http.post(this.url + '/api/token/logout', {token: token}, {headers: headers});
  }

  logout() {
    console.log('logout');
    if (this.user && this.user.token) {
      this._logout(this.user.token).subscribe((res) => {
        this.router.navigate(['login']);
      }, err => {
        this.router.navigate(['login']);
      });
      this.circuito = null;
      this.user = null;
      this.storage.clear();
    } else {
      this.circuito = null;
      this.user = null;
      this.storage.clear();
      this.router.navigate(['login']);
    }
    this.storage.clear();
    this.router.navigate(['login']);
  }

  /**** Regisro para admin ****/

  registro(body) {
    const headers = this.headers();
    return this.http.post(this.url + '/api/init/createAccount', body, {headers: headers});
  }

  /**
   * Wizard registration: creates user + default group/team + demo assignment in one transaction.
   * Payload: { name, email, password|pass, plan: 'trial'|'paypal', paypalPaymentId? }
   * Uses same endpoint POST /api/init/createAccount with extended semantics.
   * Kept separate for intent clarity; behaves identically to registro() on the wire.
   * When USE_MOCK is true, returns a simulated Observable without hitting the network.
   */
  createAccountWithSetup(payload: any) {
    const headers = this.headers();
    // Normalize to backend contract: ensure both password and pass are present
    const body: any = Object.assign({}, payload);
    if (body.password && !body.pass) {
      body.pass = body.password;
    }
    if (body.pass && !body.password) {
      body.password = body.pass;
    }
    // PayPal alias: backend expects paymentProvider+paymentId, docs/legacy use paypalPaymentId — send both
    if (body.paypalPaymentId && !body.paymentId) {
      body.paymentId = body.paypalPaymentId;
    }
    if (body.paymentId && !body.paypalPaymentId) {
      body.paypalPaymentId = body.paymentId;
    }
    if ((body.paypalPaymentId || body.paymentId) && !body.paymentProvider) {
      body.paymentProvider = 'paypal';
    }

    if (this.USE_MOCK) {
      if (body.email === 'error@test.com') {
        return Observable.throw({ error: { message: 'Email ya registrado' } }).delay(1200);
      }
      // C2 contract sentinels: 409 conflict / 400 invalid payload
      if (body.email === 'conflict@test.com') {
        return Observable.throw({ status: 409, error: { code: 'email_exists', message: 'Email ya registrado' } }).delay(1200);
      }
      if (body.email === 'invalid@test.com') {
        return Observable.throw({ status: 400, error: { code: 'invalid_payload', message: 'Datos de registro inválidos' } }).delay(1200);
      }
      const trialEndsAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
      // Legacy invite path (no planId): old-branch shape without circuito
      if (!body.planId) {
        return Observable.of({
          token: 'mock-jwt-token-' + Date.now(),
          user: {
            _id: 'mock-user-1',
            name: body.name,
            email: body.email,
            plan: body.plan,
            trialEndsAt: trialEndsAt,
            subscriptionStatus: body.plan === 'trial' ? 'trial' : 'active'
          },
          group: { _id: 'mock-group-1', name: 'Grupo General' },
          team: { _id: 'mock-team-1', name: 'Pantalla 1' },
          trialEndsAt: trialEndsAt
        }).delay(1200);
      }
      const mockResponse: any = {
        token: 'mock-jwt-token-' + Date.now(),
        user: {
          _id: 'mock-user-1',
          name: body.name,
          email: body.email,
          plan: body.plan,
          trialEndsAt: trialEndsAt,
          subscriptionStatus: body.plan === 'trial' ? 'trial' : 'active'
        },
        group: { _id: 'mock-group-1', name: 'Grupo General' },
        team: { _id: 'mock-team-1', name: 'Pantalla 1' },
        trialEndsAt: trialEndsAt,
        circuito: {
          planId: body.planId,
          guid: 'mock-circuito-guid-1',
          status: body.plan === 'trial' ? 'TRIAL' : 'ACTIVE'
        }
      };
      if (body.paypalPaymentId) {
        mockResponse.paypalPaymentId = body.paypalPaymentId;
      }
      return Observable.of(mockResponse).delay(1200);
    }

    return this.http.post(this.url + '/api/init/createAccount', body, {headers: headers});
  }

  /**** Activacion de cuenta ****/

  activateAccount(token: string) {
    const headers = this.headers();
    return this.http.post(this.url + '/api/init/activate', { token: token }, { headers: headers });
  }

  resendActivation(email: string) {
    var headers = this.headers();
    return this.http.post(this.url + '/api/init/resend-activation', { email: email }, { headers: headers });
  }

  /**** Recuperacion de contraseña ****/

  recoveryPass(email) {
    const headers = this.headers();
    return this.http.post(this.url + '/api/init/recoveryPass', {email: email}, {headers: headers});
  }

  changePassRecovery(body) {
    const headers = this.headers();
    return this.http.put(this.url + '/api/init/changePassRecovery', body, {headers: headers});
  }

  changePassWithAdminCode(email, code, newPass) {
    const headers = this.headers();
    return this.http.post(this.url + '/api/init/changePassWithAdminCode', {email: email, code: code, newPass: newPass}, {headers: headers});
  }

  verifyAdminCode(email, code) {
    const headers = this.headers();
    return this.http.post(this.url + '/api/init/verifyAdminCode', {email: email, code: code}, {headers: headers});
  }

  /**** Metodo para verificar sesion de usuario ****/

  userCheck(success, error) {
    this.storage.getItem<User>(this.token_key).subscribe(
      (data) => {
        this.user = data;
        if (this.user && this.user.token) {
          this.circuito = this.user.circuito[0];
          success();
        } else {
          this.logout();
        }
      }, err => {
        error();
      });
  }

  checkError(err): AuthErrorInfo {
    if (err && err.status === 401) {
      this.logout();
    }
    const body: any = err && err.error && typeof err.error === 'object' ? err.error : null;
    const code: string | null = body && body.code != null ? body.code
      : (err && err.code != null ? err.code : null);
    const rawMessage: string | null = body && (body as any).message != null ? (body as any).message
      : (err && (err as any).message != null && typeof (err as any).message === 'string' ? (err as any).message : null);
    const status: number | null = err && (err as any).status != null ? (err as any).status : null;
    if (status === 403 && code === 'plan_limit_screens') {
      return {
        message: rawMessage || 'Has alcanzado el límite de pantallas de tu plan. Libera una pantalla o mejora tu plan.',
        cta: '/pago',
        code: code,
        planId: body && body.planId != null ? body.planId : null,
        maxScreens: body && body.maxScreens != null ? body.maxScreens : null,
        screensInUse: body && body.screensInUse != null ? body.screensInUse : null
      };
    }
    if (status === 403 && code === 'feature_not_included') {
      const feature: string | null = body && body.feature != null ? body.feature : null;
      const fallback: string = feature
        ? 'La función ' + feature + ' no está incluida en tu plan. Mejora tu plan para usarla.'
        : 'Esta función no está incluida en tu plan. Mejora tu plan para usarla.';
      return {
        message: rawMessage || fallback,
        cta: '/pago',
        code: code,
        feature: feature
      };
    }
    if (status === 400 && code === 'plan_not_available_online') {
      return {
        message: rawMessage || 'Este plan no está disponible para contratación online. Contacta a soporte.',
        cta: 'contacto',
        code: code
      };
    }
    return { message: rawMessage, cta: null, code: code };
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/auth.ts